import "./style.scss";

type Props = {
  value?: boolean;
  onChange?: (checked: boolean) => void;
  onBlur?: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
};
export const SwitchToggleInput = ({
  onChange,
  onBlur,
  value,
  disabled,
  label,
}: Props) => (
  <label className="tru-toggle-switch">
    <input
      onChange={(event) => {
        onChange?.(event.target.checked);
      }}
      onBlur={(event) => onBlur?.(event.target.checked)}
      type="checkbox"
      checked={value}
      disabled={disabled}
    />
    <span className="slider round">
      <span className="slider-ball"></span>
    </span>
    <label>{label}</label>
  </label>
);
